function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
export default ({
  className,
  fill,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "24",
  height: "24",
  className: className
}, props, {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.1 5.80887L16.94 5.83885L15.67 4.55965C15.32 4.20987 14.83 4 14.33 4H9.68C9.18 4 8.69 4.19988 8.34 4.55965L7.14 5.80887H3.9C2.85 5.80887 2 6.65834 2 7.71768V18.0912C2 19.1405 2.85 20 3.9 20H20.1C21.15 20 22 19.1505 22 18.0912V7.70768C22 6.65834 21.15 5.79888 20.1 5.79888V5.80887ZM20 17.9913H4V7.80762H7.13C7.63 7.80762 8.12 7.60775 8.47 7.24797L9.67 5.99875L14.25 5.96877L15.52 7.24797C15.88 7.60775 16.36 7.80762 16.86 7.80762H19.99V17.9813L20 17.9913ZM12 7.60775C9.46 7.60775 7.4 9.67645 7.4 12.2149C7.4 14.7533 9.46 16.822 12 16.822C14.54 16.822 16.6 14.7533 16.6 12.2149C16.6 9.67645 14.54 7.60775 12 7.60775ZM12 14.8232C10.57 14.8232 9.4 13.654 9.4 12.2149C9.4 10.7758 10.57 9.6065 12 9.6065C13.43 9.6065 14.6 10.7758 14.6 12.2149C14.6 13.654 13.43 14.8232 12 14.8232Z",
  fill: fill || 'currentColor'
}));
//# sourceMappingURL=Camera.js.map